// 账户中心
import request from '@/utils/request'

//账户信息
export function queryMemberInfoByUserId(userId) {
    return request.post('/member/queryMemberInfoByUserId?userId=' + userId)
}

//修改用户名
export function editMemberUsername(id, newUsername) {
    return request.post('/member/editMemberUsername?id=' + id + '&newUsername=' + newUsername)
}

//用户企业认证
export function identifyCompany(param) {
    return request.post('/member/identifyCompany', param)
}

//用户个人认证
export function identifyPerson(param) {
    return request.post('/member/identifyPerson', param)
}